import {useNavigate} from 'react-router-dom'
import useStore from 'base/store'
import { PermissionType } from 'common/types'
import commonStyles from '../styles.module.scss'
import styles from './ConfirmOpenActions.variation.module.scss'
import {Text, Button, Modal} from 'common/components'
import {useOpen} from 'common/hooks'
import {RequestPushBack, CheckActionsProps, useAcceptRequestStatus,} from '..'

export default function ConfirmOpenActions({
  role,
  request,
  isRequestLoading,
}: CheckActionsProps) {
  const permissions: PermissionType[] = useStore((state) => state.permissions)
  const navigate = useNavigate()
  const onSuccess = () => { navigate(
    !!request?.project?.uuid
    ? `/projects/${request.project.uuid}`
    : '/projects'
  ) }
  const [isOpen, handleOpen, handleClose] = useOpen()
  const {
    mutate: acceptRequestStatus,
    isMutating: isAcceptRequestStatusMutating,
  } = useAcceptRequestStatus(request.uuid, onSuccess)

  const handleStatusAccept = () => { acceptRequestStatus() }
  const isBusy = isAcceptRequestStatusMutating || isRequestLoading
  const isNotAllowed = !permissions?.includes('edit variation request (confirm open)')
  return (
    <>
      <div className={commonStyles.checkActions}>
        <Text as="span" weight="demiBold">
        </Text>
        { !isNotAllowed && 
        (
          <div>
            <Button disabled={isBusy} onClick={handleOpen} style={{width: '200px'}}>
              Open
            </Button>
            <RequestPushBack
              requestUuid={request.uuid}
              disabled={isBusy}
            />
          </div>
        )}
      </div>
      
      <Modal
        narrow
        width={485}
        title={`Variation Confirmation`}
        open={isOpen}
      >
        <Text color="black" size="md" align='center'>
          Are you sure you want to proceed with the variation?
        </Text>
        <div className={styles.actions}>
          <Button style={{flex: 1}} variant='grey2' onClick={handleClose}>
            Cancel
          </Button>
          <Button style={{flex: 1}} disabled={isBusy} onClick={handleStatusAccept}>
            Confirm
          </Button>
        </div>
      </Modal>
    </>
  )
}
